/**
 * Compares two values and returns `true` if they are equal.
 *
 * @param {*} x - Current value.
 * @param {*} y - Comparison value.
 * @returns {boolean} `true` if `x == y`, otherwise `false`.
 */
export function equals(x, y) {
  // biome-ignore lint/suspicious/noDoubleEquals: intentional type coercion comparison
  return x == y;
}
